import MuiAlert from '@material-ui/lab/Alert';
import { Grid, Collapse } from '@material-ui/core';
import React from 'react';
import { TextButton } from './solteq-react/forms/Buttons';

const AlertNotification = ({ alertMessage, handleClose, styles = {} }) => {
    return (
        <>
            <style
                dangerouslySetInnerHTML={{
                    __html: `.MuiAlert-message { width: 100% }`
                }}
            />
            <Collapse in={!!alertMessage}>
                <MuiAlert elevation={6} variant="filled" severity="info" style={{ height: '36px', background: '#c2185b', ...styles }}>
                    <Grid container direction="row" justifyContent="space-between" style={{ width: '100%' }}>
                        <Grid item /*alignContent="center"*/ style={{ lineHeight: '40px' }}>
                            {alertMessage}
                        </Grid>
                        <Grid item>
                            <TextButton style={{ color: 'white' }} onClick={handleClose}>
                                OK
                            </TextButton>
                        </Grid>
                    </Grid>
                </MuiAlert>
            </Collapse>
        </>
    );
};

export default AlertNotification;
